import React from 'react';
import * as Sentry from '@sentry/react';
import env from '@beam-australia/react-env';
import { getState } from 'store';
import reactAppEnv, { isLocalEnv } from 'utils/reactAppEnv';

const META_DATA_CONTEXT = 'Meta data';

const SentryWrapper = ({ children }) => {
  // Don't call Sentry API if we are working locally
  if (isLocalEnv()) {
    return children;
  }

  const {
    session: {
      uid,
    },
  } = getState();

  Sentry.init({
    dsn: env('SENTRY_DSN'),
    environment: reactAppEnv(),
    tracePropagationTargets: [/^\/(?!\/)/],
    ignoreErrors: [
      'A network error occurred.',
    ],
    tracesSampleRate: 0.1,
    normalizeDepth: 5,
    release: env('VERSION'),
    integrations: [
      new Sentry.BrowserTracing(),
    ],
    beforeSend(event) {
      const metaDataContext = {
        gigyaId: uid,
      };

      // eslint-disable-next-line no-param-reassign
      event.contexts = {
        ...event.contexts,
        [META_DATA_CONTEXT]: {
          ...event.contexts?.[META_DATA_CONTEXT],
          ...metaDataContext,
        },
      };

      return event;
    },
  });

  return <Sentry.ErrorBoundary>{children}</Sentry.ErrorBoundary>;
};

export default SentryWrapper;
